import App from './App';

import convetJsonToGeoJson from './utils/convertJsonToGeoJson';

export default function(object) {
  const maps = [...object.maps];
  const convertedMaps = maps.map(map => ({ ...map, data: convetJsonToGeoJson(map.data) }));

  App({ maps: convertedMaps, lang: object.lang, translation: object.translation });
}
